import { ValidationError } from 'modules/application/detail/portal-submodule-builder/templates/builder/models/validators/ValidatorError';
import { Validator } from 'modules/application/detail/portal-submodule-builder/templates/builder/models/validators/Validator';
import { CommonStateViewModelValidator } from './CommonStateViewModelValidator';
import { PaymentStateViewModelValidator } from './PaymentStateViewModelValidator';
import { PaymentConstants } from '../../payment/PaymentConstants';
export class StateViewModelValidator extends Validator {
    constructor() {
        super();
        this.commonStateModelValidator = new CommonStateViewModelValidator();
        this.paymentStateViewModelValidator = new PaymentStateViewModelValidator();
        this.contentActionViewModelValidator = this.commonStateModelValidator.contentActionViewModelValidator;
        this.actionViewModelValidator = this.commonStateModelValidator.actionViewModelValidator;
        this.outputViewModelValidator = this.commonStateModelValidator.outputViewModelValidator;
    }
    validate(model) {
        // Verificar se é um bloco de pagamento
        if (model.id && model.id.startsWith(PaymentConstants.STATE_ID_PREFIX)) {
            // Usar validador específico para blocos de pagamento
            this.paymentStateViewModelValidator.validate(model);
            return;
        }
        // Validação padrão para outros blocos
        if (model.$title == '' || model.$title == undefined) {
            throw new ValidationError('The title is required');
        }
        if (!model.$position) {
            throw new ValidationError('The position is required');
        }
        this.commonStateModelValidator.validate(model);
    }
}
